// import React, { useState, useEffect, useContext } from "react";
// import DataTable from "react-data-table-component";
// import AuthContext from "../../contexts/AuthContext";
// import "./contact-us-details.css";

// const ContactUsDetails = () => {
//   const { token } = useContext(AuthContext);

//   const [contacts, setContacts] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [page, setPage] = useState(1);
//   const [pageSize, setPageSize] = useState(10);
//   const [totalRows, setTotalRows] = useState(0);

//   const [searchFilters, setSearchFilters] = useState({
//     userName: "",
//     userEmail: "",
//     userPhoneNo: "",
//     fromDate: "",
//     toDate: "",
//   });

//   useEffect(() => {
//     fetchContacts();
//   }, [page, pageSize, searchFilters]);

//   const fetchContacts = async () => {
//     setLoading(true);
//     try {
//       const response = await fetch(
//         `${process.env.REACT_APP_API_BASE_URL}/contact/search`,
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//           body: JSON.stringify({
//             ...searchFilters,
//             pageNo: page,
//             pageSize,
//           }),
//         }
//       );

//       const data = await response.json();
//       setContacts(data?.data || []);
//       setTotalRows(data?.totalResult || 0);
//     } catch (error) {
//       console.error("Error fetching contacts:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handlePageChange = (newPage) => {
//     setPage(newPage);
//   };

//   const handleRowsPerPageChange = (newPageSize, newPage) => {
//     setPageSize(newPageSize);
//     setPage(newPage); // keeps pagination consistent
//   };

//   const columns = [
//     {
//       name: "Name",
//       selector: (row) => row?.userName || "-",
//       sortable: true,
//     },
//     {
//       name: "Email",
//       selector: (row) => row?.userEmail || "-",
//       sortable: true,
//     },
//     {
//       name: "Phone",
//       selector: (row) => row?.userPhoneNo || "-",
//       sortable: true,
//     },
//     {
//       name: "Message",
//       cell: (row) => (
//         <div className="order-id-cell" title={row?.userMessage}>
//           {row?.userMessage}
//         </div>
//       ),
//     },
//     {
//       name: "Date",
//       selector: (row) => row?.createdDate || "-",
//       sortable: true,
//     },
//   ];

//   return (
//     <main className="contact-us-details py-3">
//       <div className="our-container">
//         <div className="inner-container">
//           <section className="contact-us-details-main-block">
//             <div className="contact-us-details-header">
//               <h1>Contact Us Details</h1>
//             </div>
//           </section>

//           <div className="contact-us-details-body">
//             <DataTable
//               columns={columns}
//               data={contacts}
//               progressPending={loading}
//               pagination
//               paginationServer
//               paginationTotalRows={totalRows}
//               paginationPerPage={pageSize}
//               onChangePage={handlePageChange}
//               onChangeRowsPerPage={handleRowsPerPageChange} // ✅ FIX
//               highlightOnHover
//             />
//           </div>
//         </div>
//       </div>
//     </main>
//   );
// };

// export default ContactUsDetails;


import React, { useState, useEffect, useContext } from "react";
import DataTable from "react-data-table-component";
import AuthContext from "../../contexts/AuthContext";
import AdminLayout from "../../layouts"; // Ensure this is wrapped if needed
import "./contact-us-details.css";

const ContactUsDetails = () => {
  const { token } = useContext(AuthContext);

  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRows, setTotalRows] = useState(0);

  // 1. Temporary state for input fields
  const [filters, setFilters] = useState({
    userName: "",
    userEmail: "",
    phoneNo: "",
    fromDate: "",
    toDate: "",
  });

  // 2. State that actually triggers the API fetch
  const [activeSearch, setActiveSearch] = useState({});

  useEffect(() => {
    fetchContacts();
  }, [page, pageSize, activeSearch]);

  const fetchContacts = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/contact/search`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            ...activeSearch,
            pageNo: page,
            pageSize,
          }),
        }
      );

      const data = await response.json();
      setContacts(data?.data || []);
      setTotalRows(data?.totalResult || 0);
    } catch (error) {
      console.error("Error fetching contacts:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const handleSearch = () => {
    setPage(1); // Reset to first page on new search
    setActiveSearch(filters);
  };

  const handleClear = () => {
    const emptyFilters = {
      userName: "",
      userEmail: "",
      phoneNo: "",
      fromDate: "",
      toDate: "",
    };
    setFilters(emptyFilters);
    setActiveSearch(emptyFilters);
  };

  const columns = [
    { name: "Name", selector: (row) => row?.userName || "-", sortable: true },
    { name: "Email", selector: (row) => row?.userEmail || "-", sortable: true },
    { name: "Phone", selector: (row) => row?.userPhoneNo || "-", sortable: true },
    {
      name: "Message",
      cell: (row) => (
        <div className="order-id-cell" title={row?.userMessage}>
          {row?.userMessage}
        </div>
      ),
    },
    { name: "Date", selector: (row) => row?.createdDate || "-", sortable: true },
  ];

  return (
    <AdminLayout>
      <div className="contact-us-details">
        <div className="contact-us-details-header">
          <h1>Contact Us Details</h1>
        </div>

        {/* --- SEARCH FILTER UI SECTION --- */}
        <div className="search-filter-card">
          <div className="search-grid">
            <div className="filter-group">
              <label>Name:</label>
              <input
                type="text"
                name="userName"
                placeholder="Enter Name"
                value={filters.userName}
                onChange={handleInputChange}
              />
            </div>
            <div className="filter-group">
              <label>Email:</label>
              <input
                type="email"
                name="userEmail"
                placeholder="Enter Email"
                value={filters.userEmail}
                onChange={handleInputChange}
              />
            </div>
            <div className="filter-group">
              <label>Phone No:</label>
              <input
                type="text"
                name="phoneNo"
                placeholder="Enter Phone No"
                value={filters.phoneNo}
                onChange={handleInputChange}
              />
            </div>
            <div className="filter-group">
              <label>From Date:</label>
              <input
                type="date"
                name="fromDate"
                value={filters.fromDate}
                onChange={handleInputChange}
              />
            </div>
            <div className="filter-group">
              <label>To Date:</label>
              <input
                type="date"
                name="toDate"
                value={filters.toDate}
                onChange={handleInputChange}
              />
            </div>
          </div>
          
          <div className="search-actions">
            <button className="btn-search" onClick={handleSearch}>Search</button>
            <button className="btn-clear" onClick={handleClear}>Clear</button>
          </div>
        </div>

        {/* --- DATA TABLE SECTION --- */}
        <div className="contact-us-details-body">
          <DataTable
            columns={columns}
            data={contacts}
            progressPending={loading}
            pagination
            paginationServer
            paginationTotalRows={totalRows}
            paginationPerPage={pageSize}
            onChangePage={(p) => setPage(p)}
            onChangeRowsPerPage={(ps, p) => {
              setPageSize(ps);
              setPage(p);
            }}
            highlightOnHover
          />
        </div>
      </div>
    </AdminLayout>
  );
};

export default ContactUsDetails;